import { APP_PREFIX_PATH } from "configs/AppConfig";
import { useState, useEffect, useRef } from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

const CountdownTimer = ({ countDate }) => {
  const intervalRef = useRef(null);
  const intl = useIntl();

  const dir = useSelector(({ theme }) => theme.direction);

  //   const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [target, setTarget] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    if (!countDate) {
      return;
    }

    try {
      const dateObj = new Date(countDate);
      // Check if date is valid
      if (isNaN(dateObj.getTime())) {
        console.error("Invalid date value:", countDate);
        return;
      }

      const now = Date.now();
      const tenMinutesFromNow = now + 10 * 60 * 1000; // 10 minutes in milliseconds
      const targetTime = dateObj.getTime();

      // Verify that target is valid and at least 10 minutes from now
      if (
        !isNaN(targetTime) &&
        targetTime > now &&
        targetTime >= tenMinutesFromNow
      ) {
        setTarget(targetTime);
      } else {
        // If target is invalid, less than current time, or less than 10 minutes from now
        // Set to 10 minutes from now
        const validTime = new Date(tenMinutesFromNow).toISOString();
        localStorage.setItem("countDownCapmasWebsiteTimer", validTime);
        setTarget(tenMinutesFromNow);
        console.warn(
          "Timer was invalid or too soon, reset to 10 minutes from now"
        );
      }
    } catch (error) {
      console.error("Error parsing date:", error);
      // On error, set to 10 minutes from now
      const now = Date.now();
      const tenMinutesFromNow = now + 10 * 60 * 1000;
      const validTime = new Date(tenMinutesFromNow).toISOString();
      localStorage.setItem("countDownCapmasWebsiteTimer", validTime);
      setTarget(tenMinutesFromNow);
    }
  }, [countDate]);

  useEffect(() => {
    if (target > 0) {
      intervalRef.current = setInterval(() => {
        let timeNow = Date.now();
        let defTime = target - timeNow; // Time remaining in milliseconds

        // Only navigate if timer has actually expired (and only once)
        if (defTime <= 0) {
          clearInterval(intervalRef.current);
          localStorage.removeItem("countDownCapmasWebsiteTimer");
          // Only navigate if we're still on the reset-code page
          if (window.location.pathname.includes("/resetCode/")) {
            navigate(`${APP_PREFIX_PATH}/forgetPass`);
          }
          return;
        }

        // Calculate and set time values
        let hours = Math.floor(
          (defTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        let mins = Math.floor((defTime % (1000 * 60 * 60)) / (1000 * 60));
        let secs = Math.floor((defTime % (1000 * 60)) / 1000);

        setHours(hours < 10 ? `0${hours}` : hours);
        setMinutes(mins < 10 ? `0${mins}` : mins);
        setSeconds(secs < 10 ? `0${secs}` : secs);
      }, 1000);

      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      };
    }
  }, [target, navigate, APP_PREFIX_PATH]);

  // const target = new Date(countDate).getTime();

  //   clearInterval(interval);

  //     let timeNow = new Date().getTime();
  //     let defTime = target - timeNow;
  //     // let days = Math.floor(defTime / (1000 * 60 * 60 *24));
  //     let hours = Math.floor(defTime % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
  //     let mins = Math.floor(defTime % (1000 * 60 * 60) / (1000 * 60));
  //     let secs = Math.floor(defTime % (1000 * 60) / (1000));

  //     // setDays(days);
  //     setHours(hours);
  //     setMinutes(mins);
  //     setSeconds(secs);

  //     if( target <= timeNow) {
  //         localStorage.removeItem('countDownCapmasWebsiteTimer');
  //         navigate(`${APP_PREFIX_PATH}/forgetPass`);
  //     }

  //     // if(days < 10)
  //     // {
  //     //     setDays(`0${days}`)
  //     // }
  //     if(mins < 10)
  //     {
  //         setMinutes(`0${mins}`)
  //     }
  //     if(hours < 10)
  //     {
  //         setHours(`0${hours}`)
  //     }
  //     if(secs < 10)
  //     {
  //         setSeconds(`0${secs}`)
  //     }

  // }, 1000);

  return (
    <div className="mt-5">
      <h4 className="fw-bold mb-4 text-center">
        {intl.formatMessage({ id: "count-down-timer" })}
      </h4>
      <div className="d-flex justify-content-evenly align-items-center">
        {/* <h6 className="fw-bold">
                {intl.formatMessage({id: "Days"})}:{' '}
                <span style={{color: '#3284ff'}}>
                    {days} يـوم
                </span>
            </h6> */}
        {hours > 0 && (
          <h6 className="fw-bold">
            {intl.formatMessage({ id: "the-hours" })}:{" "}
            <span style={{ color: "#3284ff" }}>
              {hours}{" "}
              {intl.formatMessage({
                id: `${
                  +hours < 2
                    ? "hour"
                    : +hours === 2
                    ? "two-hours"
                    : +hours > 2 && +hours < 11
                    ? "hours"
                    : +hours > 10
                    ? dir === "rtl"
                      ? "hour"
                      : "hours"
                    : "hours"
                }`,
              })}
            </span>
          </h6>
        )}
        <h6 className="fw-bold">
          {intl.formatMessage({ id: "the-minutes" })}:{" "}
          <span style={{ color: "#3284ff" }}>
            {minutes}{" "}
            {intl.formatMessage({
              id: `${
                +minutes < 2
                  ? "minute"
                  : +minutes === 2
                  ? "two-minutes"
                  : +minutes > 2 && +minutes < 11
                  ? "minutes"
                  : +minutes > 10
                  ? dir === "rtl"
                    ? "minute"
                    : "minutes"
                  : "minutes"
              }`,
            })}
          </span>
        </h6>
        <h6 className="fw-bold">
          {intl.formatMessage({ id: "the-seconds" })}:{" "}
          <span style={{ color: "#3284ff" }}>
            {seconds}{" "}
            {intl.formatMessage({
              id: `${
                +seconds < 2
                  ? "second"
                  : +seconds === 2
                  ? "two-seconds"
                  : +seconds > 2 && +seconds < 11
                  ? "seconds"
                  : +seconds > 10
                  ? dir === "rtl"
                    ? "second"
                    : "seconds"
                  : "seconds"
              }`,
            })}
          </span>
        </h6>
      </div>
    </div>
  );
};

export default CountdownTimer;
